import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { Get } from '@app/utils/httpProvider';
import { useQuery } from 'react-query';
import { QRCodeSVG } from 'qrcode.react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Table } from 'react-bootstrap';
import 'react-tabs/style/react-tabs.css';
import {
    ASSET_API, BaseGatewayImage
} from '../../utils/apiUrl.js';
import { isValidUrl, createUrlWithParam } from '../../utils/helper.js';
import { URI_INTERNAL } from '../../utils/pathLocations.js';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {
    USAGE_PURPOSE_OPTIONS,
    EQUIPMENT_TYPE_OPTIONS,
    EQUIPMENT_SOURCE_OPTIONS,
    FUNDING_SOURCE_OPTIONS,
    QUALITY_LEVEL_OPTIONS,
    CONNECTION_TYPE_OPTIONS,
    getLabelByValue
} from '../../constants/AssetEnums';


const AssetPublicDetail = () => {
    const { id } = useParams();
    const location = useLocation();
    const history = useHistory();
    
    // Fallback to query param if not in URL segment
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = id || paramUrl.get('id');

    const itemQuery = useQuery(['publicAsset', itemId], () =>
        Get(ASSET_API.GET_PUBLIC_ITEM, itemId)
    );

    const isLoading = itemQuery.isLoading;
    const isError = itemQuery.isError;
    const error = itemQuery.error;
    const asset = itemQuery.data;

    const getAccessoryStatusStyle = (status) => {
        switch (status) {
            case 'Hoạt động': return { bg: 'rgba(40,167,69,0.12)', border: 'rgba(40,167,69,0.5)', text: '#28a745' };
            case 'Không hoạt động': return { bg: 'rgba(108,117,125,0.12)', border: 'rgba(108,117,125,0.5)', text: '#6c757d' };
            case 'Hỏng': return { bg: 'rgba(220,53,69,0.12)', border: 'rgba(220,53,69,0.5)', text: '#dc3545' };
            default: return { bg: 'rgba(108,117,125,0.1)', border: 'rgba(108,117,125,0.4)', text: '#6c757d' };
        }
    };

    if (isLoading) return <Container className="mt-5 text-center"><h5>Đang tải thông tin tài sản...</h5></Container>;
    if (isError) return <Container className="mt-5 text-center text-danger"><h5>Có lỗi xảy ra: {error.message}</h5></Container>;
    if (!asset) return <Container className="mt-5 text-center"><h5>Không tìm thấy thông tin tài sản</h5></Container>;

    const renderField = (label, value) => (
        <Row className="mb-2 align-items-start">
            <Col sm={4} className="text-left" style={{ fontWeight: 600, color: '#495057' }}>{label}:</Col>
            <Col sm={8}>{value || '---'}</Col>
        </Row>
    );

    return (
        <Container className="mt-4 mb-4">
            <Card className="shadow">
                <Card.Header className="bg-primary text-white text-center position-relative py-3">
                    <button 
                        className="btn btn-sm btn-light position-absolute shadow-sm" 
                        onClick={() => history.goBack()}
                        style={{ left: '15px', top: '50%', transform: 'translateY(-50%)', borderRadius: '20px', padding: '5px 15px', fontWeight: 600, fontSize: '13px' }}
                    >
                        <i className="fas fa-arrow-left mr-1"></i> Quay lại
                    </button>
                    <h4 className="mb-0">CHI TIẾT TÀI SẢN</h4>
                    <button 
                        className="btn btn-sm btn-warning position-absolute shadow-sm" 
                        onClick={() => history.push(createUrlWithParam(URI_INTERNAL.ASSET_EDIT_PATH, { id: itemId }))}
                        style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', borderRadius: '20px', padding: '5px 15px', fontWeight: 600, fontSize: '13px', color: '#856404', backgroundColor: '#ffc107', borderColor: '#ffc107' }}
                    >
                        <i className="fas fa-edit mr-1"></i> Chỉnh sửa
                    </button>
                </Card.Header>
                <Card.Body>
                    <Tabs>
                        <TabList>
                            <Tab>Thông tin chung</Tab>
                            <Tab>Hình ảnh & Tài liệu</Tab>
                            <Tab>Danh sách phụ kiện</Tab>
                        </TabList>

                        <TabPanel>
                            <div className="mt-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3">Thông tin định danh</h6>
                                <Row>
                                    <Col md={5}>
                                        {renderField('Mã tài sản', asset.assetCode)}
                                        {renderField('Tên tài sản', asset.assetName)}
                                        {renderField('Số thẻ tài sản', asset.cardNumber)}
                                        {renderField('Ngày tạo thẻ', asset.cardCreatedDate ? moment(asset.cardCreatedDate).format('DD/MM/YYYY') : '')}
                                    </Col>
                                    <Col md={5}>
                                        {renderField('Nhóm tài sản', asset.assetGroupName)}
                                        {renderField('Phòng ban', asset.departmentName)}
                                        {renderField('Trạng thái', asset.assetStatusName)}
                                        {renderField('Thanh lý', asset.isDisposed ? 'Đã thanh lý' : 'Chưa thanh lý')}
                                    </Col>
                                    <Col md={2} className="text-center d-flex flex-column align-items-center justify-content-center border-left">
                                        <div style={{ fontWeight: 600, color: '#495057', marginBottom: '8px', fontSize: '13px' }}>QR Code Liên kết</div>
                                        {asset.qrCode ? (
                                            <>
                                                <div className="p-2 bg-white border rounded shadow-sm mb-2">
                                                    <QRCodeSVG value={asset.qrCode} size={90} level="M" includeMargin={true} />
                                                </div>
                                                <code className="text-truncate font-weight-bold d-block w-100 text-muted" style={{ fontSize: '12px', maxWidth: '120px' }} title={asset.qrCode}>
                                                    {asset.qrCode}
                                                </code>
                                            </>
                                        ) : (
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="text-muted mb-2" style={{ fontSize: '11px' }}>Chưa gán QR</div>
                                                <button 
                                                    className="btn btn-xs btn-outline-primary rounded-pill px-2 py-1"
                                                    onClick={() => history.push(`/asset/scan`)}
                                                    style={{ fontSize: '11px' }}
                                                >
                                                    <i className="fas fa-link mr-1"></i> Gán mã
                                                </button>
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                <h6 className="text-primary border-bottom pb-2 mt-4 mb-3">Thông số kỹ thuật</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Số Serial', asset.serialNumber)}
                                        {renderField('Model / Ký hiệu', asset.model)}
                                        {renderField('Nhà sản xuất', asset.manufacturer)}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Xuất xứ', asset.country)}
                                        {renderField('Công suất', asset.powerSpec)}
                                    </Col>
                                </Row>

                                <h6 className="text-primary border-bottom pb-2 mt-4 mb-3">Thông tin mua sắm</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Ngày mua', asset.purchaseDate ? moment(asset.purchaseDate).format('DD/MM/YYYY') : '')}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Giá trị mua', asset.purchaseValue ? asset.purchaseValue.toLocaleString('vi-VN') + ' VND' : '')}
                                    </Col>
                                </Row>

                                <h6 className="text-primary border-bottom pb-2 mt-4 mb-3">Thông tin bổ sung</h6>
                                <Row>
                                    <Col md={6}>
                                        {renderField('Mục đích SD', getLabelByValue(USAGE_PURPOSE_OPTIONS, asset.usagePurpose))}
                                        {renderField('Loại trang bị', getLabelByValue(EQUIPMENT_TYPE_OPTIONS, asset.equipmentType))}
                                        {renderField('Nguồn trang bị', getLabelByValue(EQUIPMENT_SOURCE_OPTIONS, asset.equipmentSource))}
                                        {renderField('Cấp chất lượng', getLabelByValue(QUALITY_LEVEL_OPTIONS, asset.qualityLevel))}
                                    </Col>
                                    <Col md={6}>
                                        {renderField('Người quản lý', asset.manager)}
                                        {renderField('Đơn vị tính', asset.unitOfMeasurement)}
                                        {renderField('Nguồn kinh phí', getLabelByValue(FUNDING_SOURCE_OPTIONS, asset.fundingSource))}
                                        {renderField('Loại kết nối', getLabelByValue(CONNECTION_TYPE_OPTIONS, asset.connectionType))}
                                    </Col>
                                    <Col md={12}>
                                        {renderField('Ghi chú', asset.notes)}
                                    </Col>
                                </Row>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="mt-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3">Ảnh tài sản</h6>
                                <div className="text-center mb-4">
                                    {asset.imagePath ? (
                                        <img 
                                            src={isValidUrl(asset.imagePath) ? asset.imagePath : BaseGatewayImage + asset.imagePath} 
                                            alt={asset.assetName} 
                                            className="img-fluid rounded shadow-sm" 
                                            style={{ maxHeight: '400px' }} 
                                        />
                                    ) : (
                                        <div className="p-5 bg-light border rounded">Không có ảnh tài sản</div>
                                    )}
                                </div>

                                <h6 className="text-primary border-bottom pb-2 mt-4 mb-3">Tài liệu kèm theo</h6>
                                <ul className="list-group list-group-flush">
                                    {asset.documentLink && asset.documentLink.length > 0 ? (
                                        asset.documentLink.map((link, index) => (
                                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                <span>Tài liệu {index + 1}</span>
                                                <a href={isValidUrl(link) ? link : BaseGatewayImage + (link.startsWith('/') ? '' : '/') + link} download target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-success shadow-none">
                                                    <i className="fas fa-download mr-1" /> Tải xuống
                                                </a>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="list-group-item text-muted">Không có tài liệu đính kèm</li>
                                    )}
                                </ul>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="mt-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3">Danh sách phụ kiện</h6>
                                
                                {/* Desktop Table View */}
                                <div className="table-responsive d-none d-md-block">
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr className="text-dark fw-bold text-uppercase" style={{ fontSize: '12px', background: '#f8f9fa' }}>
                                                <th className="text-center py-2" style={{ width: '50px' }}>STT</th>
                                                <th className="py-2">Mã phụ kiện</th>
                                                <th className="py-2">Tên phụ kiện</th>
                                                <th className="py-2">Quy cách</th>
                                                <th className="py-2">Đơn vị</th>
                                                <th className="text-center py-2">Số lượng</th>
                                                <th className="text-center py-2">Trạng thái</th>
                                                <th className="py-2">Ghi chú</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(!asset.accessories || asset.accessories.length === 0) && (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted">
                                                        Không có phụ kiện kèm theo
                                                    </td>
                                                </tr>
                                            )}
                                            {asset.accessories && asset.accessories.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td>{item.materialCode}</td>
                                                    <td>{item.materialName}</td>
                                                    <td>{item.specification}</td>
                                                    <td>{item.unit}</td>
                                                    <td className="text-center">{item.quantity}</td>
                                                    <td className="text-center">
                                                        {(() => {
                                                            const s = getAccessoryStatusStyle(item.accessoryStatus);
                                                            return (
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    padding: '3px 10px',
                                                                    borderRadius: '999px',
                                                                    fontSize: '11px',
                                                                    fontWeight: 700,
                                                                    background: s.bg,
                                                                    color: s.text,
                                                                    border: `1px solid ${s.border}`,
                                                                    whiteSpace: 'nowrap',
                                                                }}>
                                                                    {item.accessoryStatus}
                                                                </span>
                                                            );
                                                        })()}
                                                    </td>
                                                    <td>{item.note}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Mobile Card View */}
                                <div className="d-block d-md-none">
                                    {(!asset.accessories || asset.accessories.length === 0) ? (
                                        <div className="p-4 text-center text-muted border rounded" style={{ backgroundColor: '#fdfdfd' }}>
                                            Không có phụ kiện kèm theo
                                        </div>
                                    ) : (
                                        <div className="accessory-card-list">
                                            {asset.accessories.map((item, index) => {
                                                const s = getAccessoryStatusStyle(item.accessoryStatus);
                                                return (
                                                    <div key={item.id} className="accessory-card mb-3 p-3 border rounded shadow-sm bg-white">
                                                        <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                                                            <span className="font-weight-bold text-dark" style={{ fontSize: '15px' }}>
                                                                #{index + 1} - {item.materialName}
                                                            </span>
                                                            <span style={{
                                                                display: 'inline-block',
                                                                padding: '3px 10px',
                                                                borderRadius: '999px',
                                                                fontSize: '11px',
                                                                fontWeight: 700,
                                                                background: s.bg,
                                                                color: s.text,
                                                                border: `1px solid ${s.border}`,
                                                                whiteSpace: 'nowrap',
                                                            }}>
                                                                {item.accessoryStatus}
                                                            </span>
                                                        </div>
                                                        <div style={{ fontSize: '13px', color: '#495057' }}>
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <span className="text-muted">Mã phụ kiện:</span>
                                                                <span className="font-weight-bold">{item.materialCode || '---'}</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <span className="text-muted">Quy cách:</span>
                                                                <span>{item.specification || '---'}</span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <span className="text-muted">Số lượng:</span>
                                                                <span>{item.quantity} {item.unit || ''}</span>
                                                            </div>
                                                            {item.note && (
                                                                <div className="mt-2 pt-2 border-top text-muted" style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                                                    <strong>Ghi chú:</strong> {item.note}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </TabPanel>
                    </Tabs>
                </Card.Body>
                <Card.Footer className="text-center text-muted small">
                    Hệ thống Quản lý Trang thiết bị - {new Date().getFullYear()}
                </Card.Footer>
            </Card>
            <style dangerouslySetInnerHTML={{ __html: `
                .react-tabs__tab-list {
                    border-bottom: 1px solid #e9ecef !important;
                    padding-left: 0 !important;
                    margin-bottom: 16px !important;
                    display: flex !important;
                    overflow-x: auto !important;
                    white-space: nowrap !important;
                    scrollbar-width: none !important; /* Hide scrollbar Firefox */
                }
                .react-tabs__tab-list::-webkit-scrollbar {
                    display: none !important; /* Hide scrollbar Chrome/Safari */
                }
                .react-tabs__tab {
                    list-style: none !important;
                    display: inline-block !important;
                    padding: 8px 18px !important;
                    margin-right: 8px !important;
                    margin-bottom: 8px !important;
                    cursor: pointer !important;
                    color: #495057 !important;
                    border: 1px solid #dee2e6 !important;
                    border-radius: 30px !important;
                    background-color: #f8f9fa !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    transition: all 0.2s ease !important;
                    user-select: none !important;
                    bottom: 0 !important;
                    position: relative !important;
                }
                .react-tabs__tab:hover {
                    border-color: #007bff !important;
                    color: #007bff !important;
                    background-color: #e9f5ff !important;
                }
                .react-tabs__tab--selected {
                    background-color: #007bff !important;
                    border-color: #007bff !important;
                    color: #ffffff !important;
                    font-weight: 600 !important;
                    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.15) !important;
                }
                .react-tabs__tab--selected:hover {
                    color: #ffffff !important;
                    background-color: #007bff !important;
                }
                .react-tabs__tab:focus {
                    outline: none !important;
                }
                .accessory-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .accessory-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0,0,0,0.08) !important;
                }
            `}} />
        </Container>
    );
};

export default AssetPublicDetail;
